<template>
    <div class="legales-page">
        <div class="img">
            <img src="../assets/legales_bg.png" />
        </div>

        <div class="desc" v-if="lang=='fr'">
            <h1>Mentions Légales</h1>
            <p>A.I.M., les Editions AMELIE</p>
            <p>
            S.A.R.L. au capital social de 8.000 euros<br />

            siège social : 9 rue de la tour, 75116 Paris<br />

            R.C.S n° B 433 580 305<br />

            T.V.A intracom n° FR 27433580305
            </p>
            <p>
            Conception et réalisation du site : <a href="https://www.arboresys-conseil.fr" target="_blank">Arboresys-Conseil</a>
            </p>
            <p>
            SIte hébergé par : <a href="https://www.sharkhan.fr" target="_blank">Sharkhan</a>
            </p>
        </div>

        <div class="desc" v-if="lang=='en'">
            <h1>Legal Terms</h1>
            <p>A.I.M., les Editions AMELIE</p>
            <p>
            Limited liability company (LLC)<br />

            Head office: 9 rue de la tour, 75116 Paris<br />

            R.C.S n° B 433 580 305<br />

            Intracommunity VAT No. FR 27433580305<br />

            Data Protection Board declaration (ongoing)
            </p>
            <p>
            Website design & development : <a href="https://www.arboresys-conseil.fr" target="_blank">Arboresys-Conseil</a>
            </p>
            <p>
            Hosted by : <a href="https://www.sharkhan.fr" target="_blank">Sharkhan</a>
            </p>
        </div>


    </div>

</template>

<script>
  import FlickityBox from './FlickityBox';

  export default {

    components: {
      FlickityBox,
    },
    props: ['lang'],
    methods: {
    },
  };
</script>
<style lang="scss">
    .legales-page {
        display: flex;
        animation: fadeIn 1s;

        align-items: stretch;
        @media screen and (max-width:768px){
            flex-direction: column;
        }

        .img, .desc {
            flex: 50% 0;
        }
        @media screen and (max-width:768px) {
            .img {
                text-align: center;
            }
            .desc {margin:auto;}
        }
        @media screen and (min-width:768px) {
            .desc {
                margin-top:5rem;
            }
            .img {
                text-align: right;
                margin-right: 1rem;
                margin-top: 5rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/LegalesPage.vue